module.exports = __webpack_public_path__ + "static/campaign-highlights-47890cbcd3c36d4f75126d4af166743f.jpg";